import { render, staticRenderFns } from "./SignaturesArchivedList.vue?vue&type=template&id=4a40e7bc&scoped=true&"
import script from "./SignaturesArchivedList.vue?vue&type=script&lang=js&"
export * from "./SignaturesArchivedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a40e7bc",
  null
  
)

export default component.exports